import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const ResponsiveRow: FC<Props> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 2,
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      '@media (max-width:700px)': {
        flexDirection: 'column',
        '& > *': { width: '100%' },
      },
    }}
  >
    {children}
  </Box>
);
